import { htmlSafe } from '@ember/template';
import Component from '@glimmer/component';
import type { Dayjs } from 'dayjs';
import type { Day } from 'lumen/models';

import type { DayEvent } from './calendar-events';
import HotelEventsCalendarsDaysContentEventBar from './days/content/event-bar';
import HotelEventsCalendarsDaysDayEvents from './days/day-events';

export interface WeekData {
  days: Day[];
  displayEvents: DayEvent[];
  eventsByDay: { [integerDate: number]: DayEvent[] };
  weekNo: number;
}

interface HotelEventsCalendarsCalendarWeekSignature {
  Args: {
    addEvent: (startDate: string) => void;
    isLoading: boolean;
    maxVisibleEvents: number;
    monthMoment: Dayjs;
    refreshEvents: () => void;
    week: WeekData;
  };
}

export default class HotelEventsCalendarsCalendarWeek extends Component<HotelEventsCalendarsCalendarWeekSignature> {
  getColumnForIndex = (index: number): number => {
    return index + 1;
  };
  getEventsForDay = (day: Day): DayEvent[] => {
    return this.args.week.eventsByDay[day.integerDate] ?? [];
  };

  get gridStyle(): ReturnType<typeof htmlSafe> {
    const eventRows = Math.max(this.args.maxVisibleEvents, 1);
    // First row is fixed height for the day header. Last row uses minmax to fill remaining space.
    const fixedRows = eventRows > 1 ? `repeat(${eventRows}, 22px) ` : '';
    return htmlSafe(`grid-template-rows: 33px ${fixedRows}minmax(22px, 1fr);`);
  }

  <template>
    <div class="events-calendar__week" style={{this.gridStyle}}>
      {{! Day cells — span full height as background/clickable area }}
      {{#each @week.days as |day index|}}
        <HotelEventsCalendarsDaysDayEvents
          @addEvent={{@addEvent}}
          @column={{this.getColumnForIndex index}}
          @eventsForDay={{this.getEventsForDay day}}
          @isLoading={{@isLoading}}
          @maxVisibleEvents={{@maxVisibleEvents}}
          @model={{day}}
          @monthMoment={{@monthMoment}}
          @refreshEvents={{@refreshEvents}}
        />
      {{/each}}

      {{! Event bars — placed via CSS Grid at the week level }}
      {{#each @week.displayEvents as |dayEvent|}}
        <HotelEventsCalendarsDaysContentEventBar
          @data={{dayEvent}}
          @isLoading={{@isLoading}}
          @refreshEvents={{@refreshEvents}}
        />
      {{/each}}
    </div>
  </template>
}
